module.exports = __webpack_public_path__ + "img/brocade.673c8807.svg";